













import {Component, Watch, Vue} from 'vue-property-decorator'
import {Action, Getter, Mutation} from 'vuex-class'
import {$} from 'simpli-web-sdk'
import * as Config from 'simpli-web-sdk/lib/config'
import ModalImageDisplay from '@/components/modals/ModalImageDisplay.vue'
import ModalBarcodeDisplay from '@/components/modals/ModalBarcodeDisplay.vue'

const metaInfo = () => ({
  title: $.t('app.subtitle'),
  titleTemplate: `%s | ${$.t('app.title')}`,
})

@Component({
  metaInfo,
  components: {ModalBarcodeDisplay, ModalImageDisplay},
})
export default class App extends Vue {
  toastStyle = Config.ToastDefaultStyle

  @Watch('$route.path')
  routePathEvent() {
    document.body.style.overflowY = 'unset'
  }

  // Standard Behaviours
  created() {
    const toastConfig = Config.ToastDefaultConfig
    toastConfig.bodyMaxLength = 300

    this.$snotify.setDefaults({
      global: Config.ToastGlobalConfig,
      toast: toastConfig,
    })
  }
}
